import { render, staticRenderFns } from "./EmptyTable.vue?vue&type=template&id=3b0d952f"
import script from "./EmptyTable.vue?vue&type=script&lang=js"
export * from "./EmptyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports